import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/**
 * Représente un élément du menu contextuel d'un tableau du détail.
 */
export class DetailTablePanelContextMenuItem<T> {
    /**
     * Constructeur.
     * @param menuItemText : Texte de l'élément du menu.
     * @param menuItemId : Identifiant de l'élément du menu.
     * @param menuItemData : Données attachées à l'élément du menu.
     * @param menuItemIcon : Icône de l'élément du menu.
     */
    constructor(
        public menuItemText: string,
        public menuItemId: string,
        public menuItemData: T,
        public menuItemIcon: IconDefinition
    ) {}
}
